// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type ChevronUp24Props = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const ChevronUp24: FC<ChevronUp24Props> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="24"
            height="24"
        >
            <path d="m19.2 13.657-1.208 1.486L12 10.24l-5.992 4.903L4.8 13.657 12 7.76l7.2 5.897Z" />
        </svg>
    );
};

export default ChevronUp24;
